import { render, staticRenderFns } from "./SonsMergeInsightPopup.vue?vue&type=template&id=45bf99d6&scoped=true"
import script from "./SonsMergeInsightPopup.vue?vue&type=script&lang=js"
export * from "./SonsMergeInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./SonsMergeInsightPopup.vue?vue&type=style&index=0&id=45bf99d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf99d6",
  null
  
)

export default component.exports